import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import {
  AndroidIcon,
  IphoneIcon,
  BackendIcon,
  CPAppIcon,
} from "../../../app-constants";

const StackItem = [
  {
    icon: IphoneIcon,
    title: "Healthcare Application",
    description:
      "Improve patient care with secure, HIPAA-compliant healthcare solutions",
  },
  {
    icon: AndroidIcon,
    title: "Fintech Applications",
    description:
      "Enhance financial services with cutting-edge, secure mobile banking apps",
  },
  {
    icon: CPAppIcon,
    title: "Social Applications",
    description:
      "Grow connections and engagement with intuitive, interactive social networking platforms",
  },
  {
    icon: BackendIcon,
    title: "Educational Applications",
    description:
      "Transform learning experiences with personalized, interactive educational apps",
  },
];

function Technology(props) {
  return (
    <div className="technoloy_sec p-100">
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={6} lg={6} xl={5} xxl={5} className="">
            <div className="example" data-text="Tech">
              <h2>An App Development Company in Austin For All</h2>
            </div>
          </Col>
          <Col
            xs={12}
            md={6}
            lg={6}
            xl={6}
            xxl={6}
            className="my-auto offset-xl-1"
          >
            <p>
              TekRevol extends its mobile app development expertise to over 15
              different industries. From niche-specific business analysis to
              experience-rich functionalities to scalable deployment, we help
              all-sized businesses across domains get the best mobile
              application – that boosts revenues and meets modern user needs.
            </p>
          </Col>
          <Col xs={12} md={12} lg={12} xl={11} xxl={11} className="m-auto">
            <div className="technology_main">
              {StackItem.map((item, index) => (
                <div className="technology_item">
                  <div className="svg_icon">{item.icon}</div>
                  <h6>{item.title}</h6>
                  <p>{item.description}</p>
                </div>
              ))}
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Technology;
